import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
/**
 * \@title Slide-toggle with forms
 */
export class SlideToggleFormsExample {
  isChecked = true;
  formGroup: FormGroup;
/**
 * @param {?} formBuilder
 */
constructor(formBuilder: FormBuilder) {
    this.formGroup = formBuilder.group({
      enableWifi: '',
      acceptTerms: ['', Validators.requiredTrue]
    });
  }
/**
 * @param {?} formValue
 * @return {?}
 */
onFormSubmit(formValue: any) {
    alert(JSON.stringify(formValue, null, 2));
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'slide-toggle-forms-example',
  templateUrl: './slide-toggle-forms-example.html',
  styleUrls: ['./slide-toggle-forms-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormBuilder, },
];
}

function SlideToggleFormsExample_tsickle_Closure_declarations() {
/** @type {?} */
SlideToggleFormsExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SlideToggleFormsExample.ctorParameters;
/** @type {?} */
SlideToggleFormsExample.prototype.isChecked;
/** @type {?} */
SlideToggleFormsExample.prototype.formGroup;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
